/**
 * ?-Symbol in der Kopfleiste (PV-037, A11) mit Zählmarke für neue News. Gibt es neue News, führt
 * der Klick direkt zu /hilfe#news; die Marke verschwindet, sobald die Hilfeseite „gelesen" meldet.
 */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ungelesenAnzahl, useNews, zaehlmarkeText } from '../../../lib/news.js';

export function HilfeKnopf() {
  const { t } = useTranslation();
  const news = useNews();
  const anzahl = news.data ? ungelesenAnzahl(news.data.items, news.data.gelesen_bis) : 0;
  const marke = zaehlmarkeText(anzahl);
  const beschriftung =
    anzahl > 0 ? t('hilfe.seite.knopf_label_neu', { count: anzahl }) : t('hilfe.seite.knopf_label');
  return (
    <Link
      to={anzahl > 0 ? '/hilfe#news' : '/hilfe'}
      aria-label={beschriftung}
      title={beschriftung}
      className="relative inline-flex h-7 w-7 items-center justify-center rounded-full border text-xs font-semibold transition-colors hover:bg-[var(--surface-2)]"
      style={{ color: 'var(--ink-2)', borderColor: 'var(--line-soft)' }}
    >
      <span aria-hidden="true">?</span>
      {marke && (
        <span
          aria-hidden="true"
          className="absolute -right-1.5 -top-1.5 min-w-[16px] rounded-full px-1 text-center text-[10px] font-semibold leading-4"
          style={{ background: 'var(--primary)', color: 'var(--surface)' }}
        >
          {marke}
        </span>
      )}
    </Link>
  );
}
